/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Sex_FemaleInputs */

const en_us2_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Women`)
};

const pt_br2_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulheres`)
};

const es_419_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mujeres`)
};

const pt_pt2_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulheres`)
};

const fr_fr2_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femmes`)
};

const de_de2_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frauen`)
};

const it_it2_exercise_personal_strength_sex_female = /** @type {(inputs: Exercise_Personal_Strength_Sex_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donne`)
};

/**
* | output |
* | --- |
* | "Women" |
*
* @param {Exercise_Personal_Strength_Sex_FemaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_sex_female = /** @type {((inputs?: Exercise_Personal_Strength_Sex_FemaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Sex_FemaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_sex_female(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_sex_female(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_sex_female(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_sex_female(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_sex_female(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_sex_female(inputs)
	return en_us2_exercise_personal_strength_sex_female(inputs)
});
export { exercise_personal_strength_sex_female as "exercise-personal.strength_sex_female" }